import React from 'react';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText } from 'material-ui/Form';
import MuInput, { InputLabel  } from 'material-ui/Input';
import MuSelect from 'material-ui/Select';
import { withStyles } from 'material-ui/styles';
import kebabCase from 'kebab-case';

import styles from '../../../constants/styles';

export const Select = ({
  classes,
  disabled,
  required,
  label,
  value,
  options,
  input,
  meta
}) => {
  const selectOptions = options.length > 1 
    ? [{ label: '', value: undefined, key: 'undefined' },
        ...options]
    : options;
  const id = kebabCase(label);
  const hasError = meta.dirty && meta.error;

  return (
    <FormControl
      error={hasError}
      fullWidth
      disabled={disabled}
      required={required}
      className={classes.formControl}
    >
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <MuSelect
        native
        value={value}
        input={<MuInput id={id} />}
        {...input}
      >
        {selectOptions.map(option =>
          <option key={option.key || option.value} value={option.value}>{option.label}</option>
        )}
      </MuSelect>
      {meta.error && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
}

export const optionsPropType = {
  key: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
};

Select.defaultProps = {
  disabled: false,
  required: false,
  value: undefined,
}

Select.propTypes = {
  classes:     PropTypes.shape({
    formControl: PropTypes.string
  }).isRequired,
  disabled:    PropTypes.bool,
  label:       PropTypes.string.isRequired,
  options:     PropTypes.arrayOf(PropTypes.shape(optionsPropType)).isRequired,
  required:    PropTypes.bool,
  value:       PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  input:       PropTypes.shape(fieldInputPropTypes).isRequired,
  meta:        PropTypes.shape(fieldMetaPropTypes).isRequired,
}

export default withStyles(styles)(Select);



// WEBPACK FOOTER //
// ./src/components/common/formComponents/Select.js